import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=1489eb40&"
import script from "./Tour.vue?vue&type=script&lang=ts&"
export * from "./Tour.vue?vue&type=script&lang=ts&"
import style0 from "./Tour.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports